var map = {
	"./arrow.png": "061e",
	"./badge-de.png": "f13e",
	"./buddha-bowl.png": "7438",
	"./building.png": "e762",
	"./burger-chips.png": "5ac0",
	"./burger-hero-mobile.png": "5259",
	"./burger-hero.png": "7c4c",
	"./burger.png": "d957",
	"./chickpea-hero-mobile.png": "73d3",
	"./chickpea-hero.png": "12be",
	"./chinese.png": "a908",
	"./curry.png": "cc27",
	"./dahl.png": "18c3",
	"./egg-burger.png": "de2b",
	"./ensaladilla.png": "abb2",
	"./jet.png": "43d2",
	"./just-eat.png": "7751",
	"./kebab.png": "9bf8",
	"./lieferando.png": "a942",
	"./logo.png": "9d64",
	"./map-ch.png": "79ba",
	"./map-de.png": "80a3",
	"./map-es.png": "b31f",
	"./map-fr.png": "dd50",
	"./map-it.png": "7cfd",
	"./map-nl.png": "16b7",
	"./map-pl.png": "e51e",
	"./mezze.png": "10c3",
	"./pancake-hero-mobile.png": "7aac",
	"./pancake-hero.png": "5445",
	"./pierogi.png": "a14f",
	"./pizza-box.png": "079b",
	"./pizza-hero-mobile.png": "b3df",
	"./pizza-hero.png": "f803",
	"./pizza-plate.png": "e3a7",
	"./pizza-slice.png": "448e",
	"./poke-salmon.png": "e221",
	"./poke-tuna.png": "500b",
	"./pyszne.png": "a972",
	"./salad.png": "37fd",
	"./skip.png": "f11a",
	"./sushi.png": "db28",
	"./takeaway.png": "3a42",
	"./thuisbezorgd.png": "e1f1",
	"./veggie-burger.png": "4b17",
	"./woman.png": "02d9",
	"./wrap.png": "b3e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";